/* eslint-disable no-console */

// Instrumentation switch — uncomment to enable ALL player/progress logs:
// window.PLAYER_DEBUG = true

export const playerLog = (...args) => {
  if (window.PLAYER_DEBUG) console.log(...args)
}

export default playerLog
